import { bindActionCreators } from 'redux';

import makeConnect from '@utils/makeConnect';

// TODO: abstract resources action imports by use of a redux registry
import userModules from '@modules/user/user.module'
import jobModule from '@modules/job/job.module'
import timesheetModule from '@modules/timesheet/timesheet.module'
import noteModule from '@modules/note/note.module.js' //TODO: remove .js, cached non .js version somewhere

const resourceActions = {
	admin: userModules.admin.actions,
	client: userModules.client.actions,
	candidate: userModules.candidate.actions,
	job: jobModule.actions,
	note: noteModule.actions,
	timesheet: timesheetModule.actions,
}

export default function UsePlural(resource) {

	if(!resourceActions[resource]) {
		throw new Error('invalid resource');
	}

	const mapStateToProps = (state, ownProps) => {
		var {data, pagination, isFetching} = state[resource];
		return {
			data: data,
			pagination: pagination,
			isLoading: isFetching,
		}
	}

	const mapDispatchToProps = dispatch => ({
		actions: bindActionCreators(resourceActions[resource], dispatch)
	})

	return makeConnect(mapStateToProps, mapDispatchToProps)

}



// WEBPACK FOOTER //
// ./src/connects/plural.js